import { tasks as actionTypes } from '$constants/action-types';

export const fetchAll = (projectId, params) => ({
  type: actionTypes.FETCH_ALL,
  projectId,
  params
});

export const fetchAllRequest = () => ({
  type: actionTypes.FETCH_ALL_REQUEST
});

export const fetchAllSuccess = (result, hasMore) => ({
  type: actionTypes.FETCH_ALL_SUCCESS,
  result,
  hasMore
});

export const fetchAllFailure = errors => ({
  type: actionTypes.FETCH_ALL_FAILURE,
  errors
});

export const createReport = (projectId, fileType, filters) => ({
  type: actionTypes.CREATE_REPORT,
  projectId,
  fileType,
  filters
});


// WEBPACK FOOTER //
// ./src/actions/tasks.js